import { Image, Transformation } from "cloudinary-react";
import React from "react";
import "./GenericImageComponent.css";

/* eslint-disable react/no-unused-prop-types */
export type CloudinaryImageConfig = {
  kind: "CloudinaryImageConfig";
  publicId: string;
};

export type UrlImageConfig = {
  kind: "UrlImageConfig";
  url: string;
};
/* eslint-enable react/no-unused-prop-types */

export type GenericImageConfig = CloudinaryImageConfig | UrlImageConfig;

function _CloudinaryImageComponent(
  props: CloudinaryImageConfig,
  width = 100,
  height = 100
): JSX.Element {
  return (
    <Image
      className="generic-image-component"
      publicId={props.publicId}
      cloudName="dfno6k3qf"
      secure="true"
    >
      <Transformation
        width={width}
        height={height}
        gravity="face"
        dpr="auto"
        crop="fill"
      />
    </Image>
  );
}

function _UrlImageConfig(props: UrlImageConfig): JSX.Element {
  return <img className="generic-image-component" src={props.url} alt="new" />;
}

export function GenericImageComponent(props: GenericImageConfig): JSX.Element {
  if (props.kind === "CloudinaryImageConfig") {
    return _CloudinaryImageComponent(props);
  } else {
    return _UrlImageConfig(props);
  }
}
